import { InjectionToken } from '@angular/core';

/**
 * Indicates that a component can be disabled.
 */
export interface WithDisabled {
  disabled: boolean;
}

export const WithDisabledToken = new InjectionToken<WithDisabled>('WithDisabledToken');
